/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const addInteraction = /* GraphQL */ `mutation AddInteraction(
  $zoneId: ID!
  $blockId: ID!
  $interactionKey: String
  $data: AWSJSON
) {
  addInteraction(
    zoneId: $zoneId
    blockId: $blockId
    interactionKey: $interactionKey
    data: $data
  ) {
    blockId
    interactionKey
    data
    participantId
    timestamp
    expires
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddInteractionMutationVariables,
  APITypes.AddInteractionMutation
>;
export const joinZone = /* GraphQL */ `mutation JoinZone(
  $zoneId: ID!
  $accessManagerBlockId: ID!
  $asAuthenticated: Boolean
  $username: String
) {
  joinZone(
    zoneId: $zoneId
    accessManagerBlockId: $accessManagerBlockId
    asAuthenticated: $asAuthenticated
    username: $username
  ) {
    zoneId
    participantId
    username
    groups
    authenticated
    active
    __typename
  }
}
` as GeneratedMutation<
  APITypes.JoinZoneMutationVariables,
  APITypes.JoinZoneMutation
>;
export const leaveZone = /* GraphQL */ `mutation LeaveZone($zoneId: ID!, $accessManagerBlockId: ID!) {
  leaveZone(zoneId: $zoneId, accessManagerBlockId: $accessManagerBlockId) {
    zoneId
    participantId
    username
    groups
    authenticated
    active
    __typename
  }
}
` as GeneratedMutation<
  APITypes.LeaveZoneMutationVariables,
  APITypes.LeaveZoneMutation
>;
export const createZone = /* GraphQL */ `mutation CreateZone(
  $zoneId: String!
  $title: String!
  $description: String!
  $branding: AWSJSON
  $username: String
) {
  createZone(
    zoneId: $zoneId
    title: $title
    description: $description
    branding: $branding
    username: $username
  ) {
    zoneId
    title
    branding
    blocks {
      zoneId
      blockId
      blockType
      index
      accessLevel
      writeAccessLevel
      groups
      options
      data
      interactions {
        items {
          blockId
          interactionKey
          data
          participantId
          timestamp
          expires
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    participants {
      items {
        zoneId
        participantId
        username
        groups
        authenticated
        active
        __typename
      }
      nextToken
      __typename
    }
    participation {
      zoneId
      participantId
      username
      groups
      authenticated
      active
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateZoneMutationVariables,
  APITypes.CreateZoneMutation
>;
export const putBlock = /* GraphQL */ `mutation PutBlock(
  $zoneId: ID!
  $blockId: ID!
  $blockType: BlockType!
  $index: Float!
  $accessLevel: Int!
  $writeAccessLevel: Int
  $groups: [String!]
  $options: AWSJSON
  $data: AWSJSON
) {
  putBlock(
    zoneId: $zoneId
    blockId: $blockId
    blockType: $blockType
    index: $index
    accessLevel: $accessLevel
    writeAccessLevel: $writeAccessLevel
    groups: $groups
    options: $options
    data: $data
  ) {
    zoneId
    blockId
    blockType
    index
    accessLevel
    writeAccessLevel
    groups
    options
    data
    interactions {
      items {
        blockId
        interactionKey
        data
        participantId
        timestamp
        expires
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PutBlockMutationVariables,
  APITypes.PutBlockMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser($username: String!, $email: String) {
  createUser(username: $username, email: $email) {
    userId
    joinedAt
    username
    email
    avatar
    zoneParticipation {
      zone {
        zoneId
        title
        branding
        __typename
      }
      participant {
        zoneId
        participantId
        username
        groups
        authenticated
        active
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const keepAlive = /* GraphQL */ `mutation KeepAlive($zoneId: ID!, $participantId: ID!, $ttl: Int) {
  keepAlive(zoneId: $zoneId, participantId: $participantId, ttl: $ttl) {
    items {
      zoneId
      participantId
      username
      groups
      authenticated
      active
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedMutation<
  APITypes.KeepAliveMutationVariables,
  APITypes.KeepAliveMutation
>;
export const addPushSubscription = /* GraphQL */ `mutation AddPushSubscription($zoneId: String!, $pushSubscription: String!) {
  addPushSubscription(zoneId: $zoneId, pushSubscription: $pushSubscription) {
    zoneId
    participantId
    username
    groups
    authenticated
    active
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddPushSubscriptionMutationVariables,
  APITypes.AddPushSubscriptionMutation
>;
export const removePushSubscription = /* GraphQL */ `mutation RemovePushSubscription($zoneId: String!, $pushSubscription: String!) {
  removePushSubscription(zoneId: $zoneId, pushSubscription: $pushSubscription) {
    zoneId
    participantId
    username
    groups
    authenticated
    active
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RemovePushSubscriptionMutationVariables,
  APITypes.RemovePushSubscriptionMutation
>;
